import type { Box } from '@mui/material';
import { type ComponentProps, useMemo } from 'react';
import type { Country, DevelopmentStatus } from '@/types/GraphqlSchema';
import { useDevelopmentStatus } from '../../../hooks/useDevelopmentStatus';
import { ChecklistFilter } from '../ChecklistFilter';

type DevelopmentStatusOverwritten = DevelopmentStatus & { isDisabled: boolean };

type DevelopmentStatusFilterProps = {
  value: DevelopmentStatusOverwritten[];
  onChange: (statuses: DevelopmentStatusOverwritten[]) => void;
  selectedCountries: Country[];
} & Omit<ComponentProps<typeof Box>, 'onChange' | 'value'>;

const DevelopmentStatusFilter = ({
  value,
  onChange,
  selectedCountries,
  ...props
}: DevelopmentStatusFilterProps) => {
  const countryCodes = useMemo(
    () => selectedCountries.map(country => country.isoCode),
    [selectedCountries],
  );

  const { developmentStatuses, loading } = useDevelopmentStatus(countryCodes, {
    fetchPolicy: 'cache-and-network',
  });

  return (
    <ChecklistFilter<DevelopmentStatusOverwritten>
      {...props}
      value={value}
      options={developmentStatuses.map(d => ({ ...d, isDisabled: !!d?.isDisabled }))}
      onChange={onChange}
      label='Development Status'
      loading={loading}
      dataId='development-status-filter'
    />
  );
};

export { DevelopmentStatusFilter };
